import styled from 'styled-components';
import device from '../../mediaQueries';

const FooterWrapper = styled.div`
  width: 100%;
  margin: auto;
  background-color: #222222;
  ${device.mobile`
  display: flex;
    flex-direction: column;
  `}
`;

export default FooterWrapper;
